import React from 'react';
import { User } from 'core/types/user';
import { Organization } from 'core/types';
import MUAvatar, { AvatarProps } from '@mui/material/Avatar';

interface Props extends AvatarProps {
  user?: Pick<User, 'profilePicture' | 'firstName' | 'lastName'>;
  organization?: Pick<Organization, 'logo' | 'name'>;
  className?: string;
}

function createInitials(firstName?: string, lastName?: string): string {
  let initials = '';
  if (firstName && firstName[0]) {
    initials += firstName[0].toUpperCase();
  }
  if (lastName && lastName[0]) {
    initials += lastName[0].toUpperCase();
  }

  return initials;
}

export default function Avatar({
  user,
  organization,
  className,
  ...props
}: Props): JSX.Element | null {
  if (user) {
    return (
      <MUAvatar
        {...props}
        className={className || ''}
        src={user.profilePicture?.url}
      >
        {createInitials(user.firstName, user.lastName)}
      </MUAvatar>
    );
  }
  if (organization) {
    return (
      <MUAvatar
        {...props}
        className={className || ''}
        src={organization.logo?.url}
      >
        {createInitials(organization.name)}
      </MUAvatar>
    );
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error('Avatar: missing `user` or `organization` prop.');
  }

  return null;
}
